<template>
  <div
    class="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-6"
  >
    <h1 class="text-8xl font-extrabold text-orange-500 mb-4">404</h1>
    <h2 class="text-2xl font-semibold text-gray-800 mb-2">Page Not Found</h2>
    <p class="text-gray-500 mb-8 max-w-md">
      Oops! The page you’re looking for doesn’t exist or may have been moved.
    </p>

    <RouterLink
      to="/portal"
      class="px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold shadow hover:bg-blue-700 active:scale-95 transition"
    >
      Back to Home
    </RouterLink>
  </div>
</template>

<style scoped>
h1 {
  animation: float 2s ease-in-out infinite alternate;
}

@keyframes float {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-8px);
  }
}
</style>
